import GoogleMap from '../Google'
import { LayerControlProps as GoogleLayerControlProps } from '../Google/LayerControl'
import MapLibre from '../MapLibre'
import { LayerControlProps } from '../MapLibre/LayerControl'
import { useInnmaxMap } from '../Provider'
import { MapType } from '../map.types'

type InnmaxLayerControlProps = {
  google?: GoogleLayerControlProps
  maplibre?: LayerControlProps
}

const InnmaxLayerControl = (props: InnmaxLayerControlProps) => {
  const { mapPlatform, mapType } = useInnmaxMap()
  const { google = {}, maplibre = {} } = props

  if (mapType === MapType.Upload || mapPlatform === 'MapLibre') {
    return <MapLibre.LayerControl {...maplibre} />
  }
  return <GoogleMap.LayerControl {...google} />
}

export default InnmaxLayerControl
